import type { Fraicheur } from '../lib/contrat';
import { anciennete, date, dateHeure } from '../lib/format';

/**
 * La fraîcheur, affichée sans exception à côté de toute synthèse.
 *
 * Un bilan de trois mois lu comme l'état actuel du dossier est le principal
 * risque d'usage de ce plugin : le commercial appelle un client en croyant
 * savoir où en est l'affaire. D'où l'ancienneté en toutes lettres, et un
 * bandeau franc quand le pipeline signale la péremption.
 */
export function BandeauFraicheur({ fraicheur }: { fraicheur: Fraicheur }) {
  const age = anciennete(fraicheur.genere_le);
  const lues = fraicheur.conversations_lues;

  return (
    <div className={`fraicheur${fraicheur.perime ? ' fraicheur--perime' : ''}`}>
      <div className="fraicheur-ligne">
        <span className="fraicheur-pastille" aria-hidden="true" />
        {fraicheur.genere_le ? (
          <span>
            Synthèse du <time dateTime={fraicheur.genere_le}>{date(fraicheur.genere_le)}</time>
            {age && <span className="fraicheur-age"> · {age}</span>}
          </span>
        ) : (
          /*
           * `genere_le` à null : c'est ce que sert /client avant la phase D.
           * « Synthèse du — » ne veut rien dire ; dire qu'on ignore la date est
           * la seule formulation honnête, et elle reste un avertissement.
           */
          <span>Date de production inconnue</span>
        )}
      </div>

      <div className="fraicheur-detail">
        {typeof lues === 'number' && (
          <span>
            {lues} conversation{lues > 1 ? 's' : ''} lue{lues > 1 ? 's' : ''}
          </span>
        )}
        {fraicheur.derniere_activite && (
          <span>Dernier échange le {date(fraicheur.derniere_activite)}</span>
        )}
      </div>

      {fraicheur.perime && (
        <p className="fraicheur-avertissement">
          <strong>Bilan dépassé.</strong>{' '}
          {fraicheur.motif_peremption ??
            `Une activité est postérieure au ${dateHeure(fraicheur.genere_le)}.`}{' '}
          Relisez la conversation avant d’appeler.
        </p>
      )}
    </div>
  );
}
